import {
    type DeleteOldPresidentResponseType,
    type DeleteOldPresidentRequestType
} from "./type";
import {
    request
} from "../request";

const deleteOldPresident = async (params: DeleteOldPresidentRequestType): Promise<DeleteOldPresidentResponseType> => {
    return await request<DeleteOldPresidentResponseType>("/content/deleteOldPresident", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default deleteOldPresident;
